import React from "react";
import { OMSButtonStyleL } from "../../../../app/common/common-components/OMSButton";
import { OMSDropdown } from "../../../../app/common/common-components/OMSDropdown";

const SuburbDropdown = ({
  SuburbDD,
  ProvinceID,
  TownID,
  SuburbID,
  handleSuburbDDChange,
  ButtonStatus,
  onCreateSuburbClick,
  onUpdateSuburbClick,
  onDeleteSuburbClick
}) => (
  <div className="form-group">
    <label htmlFor="Suburb">Suburb</label>
    <OMSDropdown
      id="SuburbDD"
      options={SuburbDD}
      valueField="value"
      labelField="text"
      value={SuburbID}
      onChange={handleSuburbDDChange}
    />
    {ProvinceID === "" || TownID === "" ? null : SuburbID === "" ? (
      <div style={{ marginTop: 5 }}>
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-plus"
          ui_type="delete"
          ui_text="Add"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onCreateSuburbClick}
        />
      </div>
    ) : (
      <div style={{ marginTop: 5 }}>
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-plus"
          ui_type="delete"
          ui_text="Add"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onCreateSuburbClick}
        />
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-edit"
          ui_type="delete"
          ui_text="Edit"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onUpdateSuburbClick}
        />
        <OMSButtonStyleL
          type="button"
          ui_icon="fa-trash-o"
          ui_type="delete"
          ui_text="Delete"
          ui_processing_text="Deleting.."
          processing={ButtonStatus.processing_delete}
          disabled={ButtonStatus.disabled}
          onClick={onDeleteSuburbClick}
        />
      </div>
    )}
  </div>
);

export default SuburbDropdown;
